import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const api = process.env.REACT_APP_API_ADDRESS;

export const modalApi = createApi({
    reducerPath: 'modalApi',
    tagTypes: ['Modal'],
    baseQuery: fetchBaseQuery({
      baseUrl: api,
      prepareHeaders: (headers) => {
        const token = localStorage.getItem("token");
        if(token) headers.set("token", token);
        return headers;
      }
    }),
    endpoints: (builder) => ({

      getModal: builder.query({
        query: () => ({
          url: "/api/modal/get",
          method: "GET"
        })
      }),


      updateModal: builder.mutation({
        query: (data) => ({
          url: '/api/modal/update',
          method: 'POST',
          body: data,
        })
      })

    }),
})

export const {
  useUpdateModalMutation,
  useGetModalQuery
} = modalApi;